import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { CustomTooltip } from 'common-ui/table/CustomTooltip';
import { getSalesProjects } from 'features/sales/salesActions';
import { selectSalesProjects } from 'features/sales/salesSlice';

import {
  Container,
  Header,
  ProjectBox,
  ProjectFlex,
  ProjectInfo,
  ProjectInfoName,
  ProjectName,
  ProjectNameBox,
  ProjectType,
  ProjectsContainer,
  SubProjectCount,
} from './Sales.styles';

const Sales = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const projects = useSelector(selectSalesProjects);

  const handleNavigate = (projectId) => {
    navigate(`/products/${projectId}`);
  };

  const truncateText = (text, maxLength) => {
    if (!text || text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  };

  const renderTruncatedText = (text, maxLength) => {
    if (!text || text.length <= maxLength) {
      return text;
    }

    return (
      <CustomTooltip title={text}>
        <span>{truncateText(text, maxLength)}</span>
      </CustomTooltip>
    );
  };

  useEffect(() => {
    dispatch(getSalesProjects({ query: {} }));
  }, [dispatch]);
  return (
    <>
      <Container>
        <Header>
          <ProjectNameBox>Projects</ProjectNameBox>
        </Header>
        <ProjectsContainer>
          {projects.map((project) => (
            <ProjectBox
              key={project.projectId}
              onClick={() => handleNavigate(project.projectId)}
            >
              <ProjectFlex>
                <ProjectName>{project.projectName}</ProjectName>
                <ProjectType>
                  {renderTruncatedText(project.projectType || '—', 10)}
                </ProjectType>
              </ProjectFlex>
              <ProjectFlex>
                <ProjectInfoName>Project description</ProjectInfoName>
                <ProjectInfo>
                  {renderTruncatedText(project.projectDescription || '—', 15)}
                </ProjectInfo>
              </ProjectFlex>
              <ProjectFlex>
                <ProjectInfoName>Subprojects</ProjectInfoName>
                <SubProjectCount>{project.subprojectsWithLeadsCount || 0}</SubProjectCount>
              </ProjectFlex>
            </ProjectBox>
          ))}
        </ProjectsContainer>
      </Container>
    </>
  );
};

export default Sales;
